import { render, staticRenderFns } from "./NewOdontogramaCrianca.vue?vue&type=template&id=0a9bc46b&scoped=true&"
import script from "./NewOdontogramaCrianca.vue?vue&type=script&lang=js&"
export * from "./NewOdontogramaCrianca.vue?vue&type=script&lang=js&"
import style0 from "./NewOdontogramaCrianca.vue?vue&type=style&index=0&id=0a9bc46b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a9bc46b",
  null
  
)

export default component.exports